var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6747 13.4898C17.1445 14.7435 16.3153 15.8483 15.2596 16.7075C14.2038 17.5668 12.9537 18.1543 11.6184 18.4188C10.2831 18.6832 8.90337 18.6166 7.59981 18.2246C6.29624 17.8327 5.10854 17.1273 4.14053 16.1703C3.17253 15.2133 2.4537 14.0337 2.04688 12.7347C1.64006 11.4357 1.55765 10.0569 1.80685 8.71864C2.05605 7.38043 2.62926 6.12363 3.47639 5.05814C4.32351 3.99264 5.41875 3.15088 6.66635 2.60645",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.2484C18.3333 9.15402 18.1178 8.07039 17.699 7.05934C17.2802 6.0483 16.6664 5.12964 15.8926 4.35582C15.1187 3.58199 14.2001 2.96817 13.189 2.54938C12.178 2.13059 11.0943 1.91504 10 1.91504V10.2484H18.3333Z",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFraction);
export default __webpack_public_path__ + "static/media/icon-fraction.0922ecdc84ee0dd43ee51f5fb459018a.svg";
export { ForwardRef as ReactComponent };